export const styles = {
  root: {
    borderRadius: '4px',
    '& .uploadFiles__upload-input': {
      clip: 'rect(0 0 0 0)',
      clipPath: 'inset(50%)',
      height: 1,
      overflow: 'hidden',
      position: 'absolute',
      bottom: 0,
      left: 0,
      whiteSpace: 'nowrap',
      width: 1,
    },
    '& .uploadFiles__drop-zone': {
      padding: '12px',
      borderStyle: 'dashed',
      borderColor: '#509ED6',
      borderWidth: '2px',
      textAlign: 'center',
      minHeight: '165px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    '& .uploadFiles__trigger-btn': {
      border: '2px solid #009FDA',
      background: '#fff',
    },
  },
}
